export default "__VITE_ASSET__MRkRUhlhqYk6wXjZrGkzSA__"